import { __assign } from 'tslib';
import { createTheme } from '@material-ui/core';
import { adminThemeBreakpoints } from './breakpoints.js';
import { adminDarkPlaceholder, adminThemeZIndex, adminThemeStatus, adminThemeDefaultProps } from './customThemeProperties.js';
import { overrides } from './overrides.js';
import { basePalette, adminDarkPalette, dataVizPalette } from './palette.js';
import { adminThemeTypography } from './typography.js';

var adminDarkOptions = __assign(__assign(__assign(__assign({ themeName: 'Admin Dark', palette: __assign(__assign(__assign({}, basePalette), adminDarkPalette), dataVizPalette), breakpoints: adminThemeBreakpoints, typography: adminThemeTypography, overrides: overrides }, adminDarkPlaceholder), adminThemeZIndex), adminThemeStatus), adminThemeDefaultProps);
var adminDark = createTheme(adminDarkOptions);

export { adminDark, adminDarkOptions };
//# sourceMappingURL=adminDarkTheme.js.map
